import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

import { Form, Row, Button, Container } from 'react-bootstrap';
import { Modal, ModalManager, Effect } from 'react-dynamic-modal';

import { RiLoader4Line } from 'react-icons/ri';
import http from "../../../services/Api";
import swal from 'sweetalert';

import './index.css'

function DisableUserModal({ user_id, client_id, userType, status, onClose }) {
  const [loading, setLoading] = useState(false);
  const {  handleSubmit } = useForm();
  const body = document.getElementsByTagName('body')[0];

  const closeModal = () => {
    ModalManager.close();
    body.style.overflow = 'auto'
  }

  const handleSave = async disableUser => {
    let userStatus = "false"
    if (status === true) {
      userStatus = true
    } else {
      userStatus = false
    }

    try {
      const response = await http.post('/api/client-active-inactive', {
        user_id,
        status: userStatus
      });

      setLoading(false);
      ModalManager.close();
      body.style.overflow = 'auto'

      if (userStatus === true) {
        swal("Usuário Desativado com Sucesso!", {
          title: "Sucesso!",
          icon: "success",
        }).then(()=> {
          onClose()
        });
      } else {
        swal("Usuário Ativado com Sucesso!", {
          title: "Sucesso!",
          icon: "success",
        }).then(() =>{
          onClose()
        });
      }

      return response.data;

    } catch (e) {
      console.log(e);
      setLoading(false);

      ModalManager.close();
      body.style.overflow = 'auto'
      swal("Erro!", "Não foi possível desativar o usuário.", "error");
      return null;
    }
  }

  const style = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999999,
      overflowX: 'hidden',
      overflowY: 'auto',
      perspective: 1300,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },

    content: {
      position: 'relative',
      border: '1px solid rgba(0, 0, 0, .2)',
      width: 'inherit',
      background: '#fff',
      overflow: 'auto',
      borderRadius: '4px',
      outline: 'none',
      boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
    }
  }

  return (
    <div className="DisableUserModal">

      <Modal
        style={style}
        onRequestClose={() => { }}
        effect={Effect.Fall}>
        <Container fluid>
          <div className="header">
            <div className="title">
              {status ? 'Desativar Usuário' : 'Ativar usuário'}
          </div>
          </div>
          {status === true ? 
          (<div>
            <p>Tem certeza que deseja desativar esse usuário?</p>
          </div>)
            : (<div>
              <p>Tem certeza que deseja ativar esse usuário?</p>
            </div>)}

          <div className="body">
            <Form method="POST" onSubmit={handleSubmit(handleSave)}>
              <Form.Group as={Row}>
                <Button variant="primary" className="customBtn" type="submit" sm6>
                  {
                    loading ? (<RiLoader4Line className="spin" />) : 'Sim'
                  }
                </Button>
                <Button variant="primary" className="customBtn" sm6 onClick={closeModal}>
                  {
                    loading ? (<RiLoader4Line className="spin" />) : 'Não'
                  }
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Container>
      </Modal>
    </div>
  );
}

export default DisableUserModal;